import React from 'react'
import styled from 'styled-components'
import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'

const pages = {
    List: 'list',
    Entity: 'entity',
    Relation: 'relation',
    Planning: 'planning'
}

const Spinner = styled.div`
    border-radius: 50%;
    width: 2.5em;
    height: 2.5em;
    animation-fill-mode: both;
    animation: loader 1.8s infinite ease-in-out;

    &:before,
    &:after {
        border-radius: 50%;
        width: 2.5em;
        height: 2.5em;
        animation-fill-mode: both;
        animation: loader 1.8s infinite ease-in-out;
    }

    color: #415dd4;
    font-size: 10px;
    margin: 80px auto;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;

    &:before,
    &:after {
        content: '';
        position: absolute;
        top: 0;
    }

    &:before {
        left: -3.5em;
        animation-delay: -0.32s;
    }

    &:after {
        left: 3.5em;
    }

    @keyframes loader {
        0%,
        80%,
        100% {
            box-shadow: 0 2.5em 0 -1.3em;
        }
        40% {
            box-shadow: 0 2.5em 0 0;
        }
    }

`

const Container = styled.div`
    position: fixed;
    background: rgba(60, 61, 76, 0.5);
    z-index: 1400;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${props => props.visible ? 1 : 0};
    transition: opacity 300ms cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: ${props => props.visible ? 'auto' : 'none'};
`

const Loader = () => {
	let location = useLocation()
	const pathname = location.pathname

	const isLoadingLogin = useSelector(state => state.login.isLoading)
    const isLoadingApplications = useSelector(state => state.applications.isLoading)
    const isLoadingDocuments = useSelector(state => state.collection.isLoading)
    const isLoadingRecord = useSelector(state => state.record.isLoading)
    const isLoadingEntities = useSelector(state => state.entities.isLoading)
    const isLoadingModules = useSelector(state => state.modules.isLoading)
    const isLoadingPlannings = useSelector(state => state.plannings.isLoading)
    const isLoadingExcelExport = useSelector(state => state.excel.isLoading)
    const isLoadingPublicTable = useSelector(state => state.publictables.isLoading)
    const isLoadingPublicForm = useSelector(state => state.publicforms.isLoading)
    const isLoadingSms = useSelector(state => state.sms.isLoading)
    const isLoadingEmail = useSelector(state => state.email.isLoading)
    const isLoadingExport = useSelector(state => state.exportdata.isLoading)
    const isLoadingStatistics = useSelector(state => state.statistics.isLoading)
    const isLoadingPdf = useSelector(state => state.pdf.isLoading)
    const isLoadingScheduler = useSelector(state => state.scheduler.isLoading)

	const isCollection = pathname.includes(pages.List) || pathname.includes(pages.Entity) || pathname.includes(pages.Relation)
	const isPlanning = pathname.includes(pages.Planning)
	const loading = isLoadingLogin || isLoadingApplications ||
		(isLoadingDocuments && isCollection) || isLoadingEntities ||
		(isLoadingPlannings && isPlanning) || isLoadingRecord || isLoadingExcelExport ||
		isLoadingPublicTable || isLoadingPublicForm ||
		isLoadingSms || isLoadingEmail || isLoadingExport ||
		isLoadingStatistics || isLoadingModules || isLoadingPdf || isLoadingScheduler

	return (
		<Container visible={loading}>
			{loading &&
				<Spinner />
			}
		</Container>
	)
}

export default Loader
